'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/react-mapstate/~/react/react.js
// module id = 2470
// module chunks = 0